import { render, staticRenderFns } from "./SingleCommissionRoPaid.vue?vue&type=template&id=2f672a98"
import script from "./SingleCommissionRoPaid.vue?vue&type=script&lang=js"
export * from "./SingleCommissionRoPaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports